import React from "react";
import { Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";
import IncomeViewModal from "./IncomeViewModal";
import { PulseLoader } from "react-spinners";

const Income = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    AllIncome,
    isLoading,
  } = IncomeViewModal();

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Income</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Income</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Income</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to="/user/admin/income/add"
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {isLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>#</th>
                            <th>Type</th>
                            {/* <th>Income Source</th> */}
                            <th>Amount</th>
                            <th>Date</th>
                            <th className="text-end">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {AllIncome?.length > 0
                            ? AllIncome.map((income, i) => {
                                return (
                                  <tr key={income.id}>
                                    <td>{i + 1}</td>
                                    <td>
                                      <h2 className="text-capitalize">
                                        <a>{income.IncomeType}</a>
                                      </h2>
                                    </td>

                                    {/* <td>{income.ExpensePurchaseSource}</td> */}
                                    <td>{income.IncomeAmount} Rs</td>
                                    <td>{income.Date}</td>

                                    <td className="text-end actions">
                                      <Link
                                        className="btn btn-sm bg-success-light me-2 "
                                        to={`/user/admin/income/update?id=${income.id}`}
                                      >
                                        <Edit size={18} />
                                      </Link>
                                      <a
                                        className="btn btn-sm bg-success-light me-2 "
                                        onClick={() => {
                                          handleOpenDeleteDialog(income.id);
                                        }}
                                      >
                                        <Trash2 size={18} />
                                      </a>
                                    </td>
                                  </tr>
                                );
                              })
                            : ""}
                        </tbody>
                      </table>
                      {AllIncome?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this Income?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default Income;
